import { Routes, Route } from "react-router-dom";
import LegacyFrontoffice from "./LegacyFrontoffice";
import SigninPage from "./auth/pages/SigninPage";
import CallbackPage from "./auth/pages/CallbackPage";
import { backofficeRoutes } from "./backoffice/router";
import FrontofficeLayout from "./frontoffice/layout/FrontofficeLayout";
import HydratedLegacyPage from "./frontoffice/HydratedLegacyPage";
import HydratedLegacyDetail from "./frontoffice/HydratedLegacyDetail";
import SearchPage from "./frontoffice/pages/SearchPage";
import PublishRequestPage from "./frontoffice/pages/PublishRequestPage";

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/signin" element={<SigninPage />} />
      <Route path="/callback" element={<CallbackPage />} />
      {backofficeRoutes}

      {/* Legacy mockup pages, hydrated with backend data */}
      <Route path="/" element={<HydratedLegacyPage />} />
      <Route path="/parcours" element={<HydratedLegacyPage />} />
      <Route path="/parcours/:id" element={<HydratedLegacyDetail />} />

      {/* New TSX pages wrapped in the FO layout */}
      <Route element={<FrontofficeLayout />}>
        <Route path="/search" element={<SearchPage />} />
        <Route path="/publier" element={<PublishRequestPage />} />
      </Route>

      {/* Other legacy routes (/explore, /organization, …) — no hydration */}
      <Route path="*" element={<LegacyFrontoffice />} />
    </Routes>
  );
}
